import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography
} from "@mui/material";

import { Formik } from "formik";
import * as Yup from "yup";
import AnimateButton from "../../../Layout/components/@extended/AnimateButton";
import {
  strengthColor,
  strengthIndicator
} from "../../../Layout/utils/password-strength";

import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import axios from "axios";
import AuthWrapper from "./AuthWrapper";

const ResetPassword = () => {
  let navigate = useNavigate();

  const [level, setLevel] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const changePassword = (value) => {
    const temp = strengthIndicator(value);
    setLevel(strengthColor(temp));
  };

  const onSubmit = (values) => {
    const { newPassword, confirmPassword } = values;
    if (newPassword !== confirmPassword) {
      setErrorMessage("Passwords entered do not match.");
    }
    try {
      axios
        .post("/auth/resetPassword", {
          userId: window.location.href.split("/")[4],
          newPassword: newPassword
        })
        .then((res) => {
          if (res.data.ok) navigate("/resetSuccessful");
          else if (res.data.error === "SAMEPASS")
            setErrorMessage(
              "New password cannot be the same as the old password. Please try again."
            );
          else setErrorMessage(res.data.error);
        });
    } catch (err) {}
  };

  return (
    <AuthWrapper>
      <Formik
        initialValues={{
          newPassword: "",
          confirmPassword: ""
        }}
        validationSchema={Yup.object().shape({
          newPassword: Yup.string()
            .max(255)
            .required("New password is required"),
          confirmPassword: Yup.string()
            .max(255)
            .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        })}
        onSubmit={onSubmit}
      >
        {({
          errors,
          handleChange,
          handleBlur,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <InputLabel htmlFor="password-signup">
                    New Password
                  </InputLabel>
                  <OutlinedInput
                    fullWidth
                    id="newPassword-signup"
                    type={showPassword ? "text" : "password"}
                    value={values.newPassword}
                    name="newPassword"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      changePassword(e.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          size="large"
                        >
                          {showPassword ? (
                            <EyeOutlined />
                          ) : (
                            <EyeInvisibleOutlined />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    placeholder="******"
                    inputProps={{}}
                  />
                  {touched.newPassword && errors.newPassword && (
                    <FormHelperText error id="helper-text-newPassword-signup">
                      {errors.newPassword}
                    </FormHelperText>
                  )}
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <InputLabel htmlFor="password-signup">
                    Confirm Password
                  </InputLabel>
                  <OutlinedInput
                    fullWidth
                    id="confirmPassword-signup"
                    type={showPassword ? "text" : "password"}
                    value={values.confirmPassword}
                    name="confirmPassword"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      changePassword(e.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          size="large"
                        >
                          {showPassword ? (
                            <EyeOutlined />
                          ) : (
                            <EyeInvisibleOutlined />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    placeholder="******"
                    inputProps={{}}
                  />
                  {touched.confirmPassword && errors.confirmPassword && (
                    <FormHelperText
                      error
                      id="helper-text-confirmPassword-signup"
                    >
                      {errors.confirmPassword}
                    </FormHelperText>
                  )}
                </Stack>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item>
                      <Box
                        sx={{
                          bgcolor: level?.color,
                          width: 85,
                          height: 8,
                          borderRadius: "7px"
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="subtitle1" fontSize="0.75rem">
                        {level?.label}
                      </Typography>
                    </Grid>
                  </Grid>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <AnimateButton>
                  <Button
                    disableElevation
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    Reset Password
                  </Button>
                </AnimateButton>
                <FormHelperText error id="helper-text-firstname-signup">
                  {errorMessage}
                </FormHelperText>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </AuthWrapper>
  );
};

export default ResetPassword;
